import script from "./exports-table-row.vue?vue&type=script&setup=true&lang=ts"
export * from "./exports-table-row.vue?vue&type=script&setup=true&lang=ts"

import "./exports-table-row.vue?vue&type=style&index=0&id=b4ba6c98&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4ba6c98"]])

export default __exports__